import { Product, BlogPost } from './types';

export const COMPANY_PHONE = "8860022021";
export const COMPANY_EMAIL = "apnavision@outlook.com";

// Reads from .env file now. If not found, falls back to empty string (or you can paste fallback here)
export const WEB3FORMS_ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY || "0241a684-64e9-4377-b03e-38e42a16ebde"; 

export const PRODUCTS: Product[] = [
  {
    id: 'p1',
    name: 'London Vision M(6021)',
    category: 'Goggles',
    price: 120,
    minQty: 12,
    description: 'Premium London Vision Sunglasses Best For high Budget and clarification',
    image: '/product/sun1.jpg',
    features: ['Metal', 'Stylish', 'Unisex'],
    inStock: true,
  },
  {
    id: 'p2',
    name: 'London Vision M(6017)',
    category: 'Goggles',
    price: 130,
    minQty: 12,
    description: 'Best London Vision Model For Metal Goggles',
    image: '/product/sun2.jpg',
    features: ['Metal', 'Stylish', 'Unisex'],
    inStock: true,
  },
  {
    id: 'p3',
    name: 'London Vision M(1002)',
    category: 'Goggles',
    price: 130,
    minQty: 12,
    description: 'Premium Rectangle London Vision Model For Metal Goggles',
    image: '/product/sun3.jpg',
    features: ['Rectangle', 'Polarized', 'Matte Finish'],
    inStock: true,
  },
  {
    id: 'p4',
    name: 'London Vision M(1009)',
    category: 'Goggles',
    price: 135,
    minQty: 12,
    description: 'Best London Vision Model and premium shape For Metal Goggles',
    image: '/product/sun4.jpg',
    features: ['Metal', 'Stylish', 'Unisex'],
    inStock: true,
  },
  {
    id: 'p5',
    name: 'London Vision M(6026)',
    category: 'Goggles',
    price: 120,
    minQty: 12,
    description: 'Premium London Vision Sunglasses Best For high Budget',
    image: '/product/sun5.jpg',
    features: ['Best Shape', 'Metal Hinge', 'Unisex'],
    inStock: true,
  },
  {
    id: 'p6',
    name: 'London Vision M(1006)',
    category: 'Goggles',
    price: 110,
    minQty: 12,
    description: 'Best London Vision Model For Metal Goggles',
    image: '/product/sun6.jpg',
    features: ['Best Design', 'Metal', 'Bold Look'],
    inStock: true,
  },
  {
    id: 'p7',
    name: 'London Vision M(6062)',
    category: 'Goggles',
    price: 120,
    minQty: 12,
    description: 'Premium London Vision Sunglasses Best For Diamond Shape',
    image: '/product/sun7.jpg',
    features: ['Metal', 'Diamond', 'Premium'],
    inStock: true,
  },
  {
    id: 'p8',
    name: 'ICI Sunglasses M(41010-04)',
    category: 'Goggles',
    price: 100,
    minQty: 12,
    description: 'Premium ICI Sunglasses Best For high Budget',
    image: '/product/sun8.jpeg',
    features: ['Metal', 'Stylish', 'Unisex'],
    inStock: true,
  },
  {
    id: 'p9',
    name: 'ICI Sunglasses M(41010-22)',
    category: 'Goggles',
    price: 100,
    minQty: 12,
    description: 'Best ICI Sunglasses  Model For Metal Goggles',
    image: '/product/sun9.jpeg',
    features: ['Metal', 'Stylish', 'ICI'],
    inStock: true,
  },
  {
    id: 'p10',
    name: 'Key Mount M(3986)',
    category: 'Goggles',
    price: 90,
    minQty: 12,
    description: 'Premium Key Mount Model',
    image: '/product/sun10.jpeg',
    features: ['Sheet', 'Polarized', 'Premium'],
    inStock: true,
  },
  {
    id: 'p11',
    name: 'Key Mount M(20159)',
    category: 'Goggles',
    price: 90,
    minQty: 12,
    description: 'Best Key Mount Model and premium shape',
    image: '/product/sun11.jpeg',
    features: ['Key Mount', 'Stylish', 'Best Shape'],
    inStock: true,
  },
  {
    id: 'p12',
    name: 'Classy Sunglasses M(1006)',
    category: 'Goggles',
    price: 170,
    minQty: 12,
    description: 'Premium Classy Sunglasses Best For high Budget',
    image: '/product/sun12.jpeg',
    features: ['Best Shape', 'Metal Hinge', 'Unisex'],
    inStock: true,
  },
  {
    id: 'p13',
    name: 'Classy Sunglasses M(1004)',
    category: 'Goggles',
    price: 165,
    minQty: 12,
    description: 'Best Classy Sunglasses Model For Metal Goggles',
    image: '/product/sun13.jpeg',
    features: ['Best Design', 'Metal', 'Bold Look'],
    inStock: true,
  },
  {
    id: 'p14',
    name: 'Classy Sunglasses M(1002)',
    category: 'Goggles',
    price: 175,
    minQty: 12,
    description: 'Best Classy Goggles For Best Shape Metal ',
    image: '/product/sun14.jpeg',
    features: ['Metal', 'Diamond', 'Premium'],
    inStock: true,
  },
  {
    id: 'p15',
    name: 'Twenty Twenty Eyewear Shine Black',
    category: 'Goggles',
    price: 90,
    minQty: 12,
    description: 'Best Twenty Twenty Eyewear For PLastic Type Goggle',
    image: '/product/sun15.jpeg',
    features: ['Plastic', 'Shine Black', 'Premium'],
    inStock: true,
  },
  {
    id: 'p16',
    name: 'Lat Sunglasses',
    category: 'Goggles',
    price: 110,
    minQty: 12,
    description: 'Best Lat Sunglasses Combo 6 model 1 piece',
    image: '/product/sun16.jpeg',
    features: ['Metal', 'Stylish', 'Best Deal'],
    inStock: true,
  },
  {
    id: 'p17',
    name: 'Pine Sunglasses M(2503)',
    category: 'Goggles',
    price: 190,
    minQty: 12,
    description: 'Best Pine Sunglasses  Model For Metal Goggles',
    image: '/product/sun17.jpeg',
    features: ['Metal', 'Stylish', 'Pine'],
    inStock: true,
  },
  {
    id: 'p18',
    name: 'Pine Sunglasses M(2515)',
    category: 'Goggles',
    price: 200,
    minQty: 12,
    description: 'Best Round SHape Pine Sunglasses For Better Look',
    image: '/product/sun18.jpeg',
    features: ['Metal', 'Polarized', 'Premium'],
    inStock: true,
  },
  {
    id: 'p19',
    name: 'Pine Sunglasses M(2508)',
    category: 'Goggles',
    price: 190,
    minQty: 12,
    description: 'Pine Sunglasses Having This Type Of Premium piece',
    image: '/product/sun19.jpeg',
    features: ['Pine', 'Stylish', 'Best Shape'],
    inStock: true,
  },
  {
    id: 'p20',
    name: 'Pine Sunglasses M(2510)',
    category: 'Goggles',
    price: 180,
    minQty: 12,
    description: 'Rectangle Shape Pine Sunglasses For Better Look',
    image: '/product/sun20.jpeg',
    features: ['Best Shape', 'Metal Hinge', 'Pine'],
    inStock: true,
  },
  {
    id: 'p21',
    name: 'Ray Ban Sunglasses(3028 Brown Dc)',
    category: 'Goggles',
    price: 480,
    minQty: 12,
    description: 'Premium high quality high branding sunglasses',
    image: '/product/sun21.jpeg',
    features: ['Metal', 'Premium', 'Expensive'],
    inStock: true,
  },
  {
    id: 'p22',
    name: 'Ray Ban Sunglasses(3028 Golden Black)',
    category: 'Goggles',
    price: 480,
    minQty: 12,
    description: 'Premium High Quality High Branding sunglasses with golden black',
    image: '/product/sun22.jpeg',
    features: ['Metal', 'Premium', 'Expensive'],
    inStock: true,
  },
  {
    id: 'p23',
    name: 'Ray Ban Sunglasses(3028 black grey dc)',
    category: 'Goggles',
    price: 450,
    minQty: 12,
    description: 'Premium High Quality High Branding sunglasses with black grey',
    image: '/product/sun23.jpeg',
    features: ['Metal', 'Premium', 'Expensive'],
    inStock: true,
  },
  {
    id: 'p24',
    name: 'Ray Ban Sunglasses(3028 golden brown)',
    category: 'Goggles',
    price: 470,
    minQty: 12,
    description: 'Premium High Quality High Branding sunglasses with golden brown',
    image: '/product/sun24.jpeg',
    features: ['Metal', 'Premium', 'Expensive'],
    inStock: true,
  },
  {
    id: 'p25',
    name: 'Royal Eyewere M(534/44)',
    category: 'Frames',
    price: 80,
    minQty: 12,
    description: 'Affordable Frames For Buyers And high Quality',
    image: '/product/frame1.jpeg',
    features: ['Plastic', 'Affordable', 'Premium'],
    inStock: true,
  },
  {
    id: 'p26',
    name: 'Royal Eyewere M(519/46)',
    category: 'Frames',
    price: 70,
    minQty: 12,
    description: 'Affordable Frames For Buyers And high Quality',
    image: '/product/Frame 2.jpeg',
    features: ['Plastic', 'Affordable', 'Premium'],
    inStock: true,
  },
  {
    id: 'p27',
    name: 'Royal Eyewere M(518)',
    category: 'Frames',
    price: 70,
    minQty: 12,
    description: 'Affordable Frames For Buyers And high Quality',
    image: '/product/frame 3.jpeg',
    features: ['Plastic', 'Affordable', 'Premium'],
    inStock: true,
  },
  {
    id: 'p28',
    name: 'Royal Eyewere M(507)',
    category: 'Frames',
    price: 80,
    minQty: 12,
    description: 'Affordable Frames For Buyers And high Quality',
    image: '/product/frame4.jpeg',
    features: ['Plastic', 'Affordable', 'Premium'],
    inStock: true,
  },
  {
    id: 'p29',
    name: 'Bold (ZN89276)',
    category: 'Frames',
    price: 160,
    minQty: 12,
    description: 'Most Stylish And fit Bold Frames Round shape',
    image: '/product/frame5.jpeg',
    features: ['Bold', 'Stylish', 'Round Shape'],
    inStock: true,
  },
  {
    id: 'p30',
    name: 'Bold (ZN89131)',
    category: 'Frames',
    price: 170,
    minQty: 12,
    description: 'Most Stylish And fit Bold Frames Rectangle shape',
    image: '/product/frame6.jpeg',
    features: ['Bold', 'Stylish', 'Rectangle Shape'],
    inStock: true,
  },
  {
    id: 'p31',
    name: 'Bold (ZN3688)',
    category: 'Frames',
    price: 180,
    minQty: 12,
    description: 'Most Stylish And fit Bold Frames Bold Rectangle shape',
    image: '/product/frame7.jpeg',
    features: ['Bold', 'Stylish', 'Rectangle Shape'],
    inStock: true,
  },
  {
    id: 'p32',
    name: 'Bold (ZN89237)',
    category: 'Frames',
    price: 190,
    minQty: 12,
    description: 'Most Stylish And fit Bold Frames Circuler Rectangle shape',
    image: '/product/Frame8.jpeg',
    features: ['Bold', 'Stylish', 'Rectangle Shape'],
    inStock: true,
  },
  {
    id: 'p33',
    name: 'Bold (ZN3709)',
    category: 'Frames',
    price: 185,
    minQty: 12,
    description: 'Most Stylish And fit Bold Frames Rectangle shape',
    image: '/product/frame9.jpeg',
    features: ['Bold', 'Stylish', 'Rectangle Shape'],
    inStock: true,
  },
  {
    id: 'p34',
    name: 'BOB Mandatory Eyewear(3194)',
    category: 'Frames',
    price: 115,
    minQty: 12,
    description: 'Best Metal Eyewear With Trusted Brand',
    image: '/product/frame10.jpeg',
    features: ['Metal', 'Stylish', 'BOB'],
    inStock: true,
  },
  {
    id: 'p35',
    name: 'BOB Mandatory Eyewear(9556)',
    category: 'Frames',
    price: 115,
    minQty: 12,
    description: 'Circuler Shape Metal Eyewear With Trusted Brand',
    image: '/product/frame11.jpeg',
    features: ['Metal', 'Stylish', 'Round Shape'],
    inStock: true,
  },
  {
    id: 'p36',
    name: 'BOB Mandatory Eyewear(3076-2)',
    category: 'Frames',
    price: 105,
    minQty: 12,
    description: 'Best Metal Eyewear With Trusted Brand',
    image: '/product/Frame13.jpeg',
    features: ['Metal', 'Stylish', 'BOB'],
    inStock: true,
  },
  {
    id: 'p37',
    name: 'BOB Mandatory Eyewear(3168)',
    category: 'Frames',
    price: 100,
    minQty: 12,
    description: 'Circuler Shape Metal Eyewear With Trusted Brand',
    image: '/product/frame14.jpeg',
    features: ['Metal', 'Stylish', 'Round Shape'],
    inStock: true,
  },
  {
    id: 'p38',
    name: 'BOB Mandatory Eyewear(9006)',
    category: 'Frames',
    price: 105,
    minQty: 12,
    description: 'Most Stylish And fit Rectangle shape',
    image: '/product/frame16.jpeg',
    features: ['Metal', 'Stylish', 'Rectangle Shape'],
    inStock: true,
  },
  {
    id: 'p39',
    name: 'BOB Mandatory Eyewear(3161)',
    category: 'Frames',
    price: 115,
    minQty: 12,
    description: 'Circuler Shape Metal Eyewear With Trusted Brand',
    image: '/product/frame17.jpeg',
    features: ['Metal', 'Stylish', 'Round Shape'],
    inStock: true,
  },
  {
    id: 'p40',
    name: 'BOB Mandatory Eyewear(7005)',
    category: 'Frames',
    price: 115,
    minQty: 12,
    description: 'Best Metal Eyewear With Trusted Brand Diamond Shape',
    image: '/product/frame18.jpeg',
    features: ['Metal', 'Stylish', 'Diamond Shape'],
    inStock: true,
  },
  {
    id: 'p41',
    name: 'Oreo Frames(321)',
    category: 'Frames',
    price: 80,
    minQty: 12,
    description: 'Best Sheet Affordable Frames',
    image: '/product/Frame19.jpeg',
    features: ['Sheet', 'Stylish', 'Rectangle Shape'],
    inStock: true,
  },
  {
    id: 'p42',
    name: 'Oreo Frames(320)',
    category: 'Frames',
    price: 75,
    minQty: 12,
    description: 'Best Sheet Affordable Frames',
    image: '/product/Frame20.jpeg',
    features: ['Metal', 'Stylish', 'Cicular Rectangle Shape'],
    inStock: true,
  },
  {
    id: 'p43',
    name: 'Oreo Frames(309)',
    category: 'Frames',
    price: 100,
    minQty: 12,
    description: 'Circuler Shape Sheet Eyewear With Trusted Brand',
    image: '/product/Frame21.jpeg',
    features: ['Sheet', 'Stylish', 'Round Shape'],
    inStock: true,
  },
  {
    id: 'p44',
    name: 'BOB mandatory Eyewear(3168) ',
    category: 'Frames',
    price: 120,
    minQty: 12,
    description: 'Best Round Frames',
    image: '/product/frame22.jpeg',
    features: ['Metal', 'Stylish', 'Cicular Shape'],
    inStock: true,
  },
  {
    id: 'p45',
    name: 'BOB mandatory Eyewear(3164)',
    category: 'Frames',
    price: 130,
    minQty: 12,
    description: 'Best Bob frames Round Shape Metal',
    image: '/product/frame23.jpeg',
    features: ['Metal', 'Stylish', 'Cicular Shape'],
    inStock: true,
  },
  {
    id: 'p46',
    name: 'Diamond Eyewear Pure Acetate (1)',
    category: 'Frames',
    price: 350,
    minQty: 12,
    description: 'Actate frame high brand high scale',
    image: '/product/frame24.jpeg',
    features: ['Acetate', 'Stylish', 'Round Shape'],
    inStock: true,
  },
  {
    id: 'p47',
    name: 'Diamond Eyewear Pure Acetate (2)',
    category: 'Frames',
    price: 350,
    minQty: 12,
    description: 'Actate frame high brand high scale',
    image: '/product/frame25.jpeg',
    features: ['Acetate', 'Stylish', 'Diamond Shape'],
    inStock: true,
  },
  {
    id: 'p48',
    name: 'Coin Game (226/46)',
    category: 'Frames',
    price: 60,
    minQty: 12,
    description: 'Best Sheet Affordable Frames',
    image: '/product/frame26.jpeg',
    features: ['Sheet', 'Stylish', 'Circular Shape'],
    inStock: true,
  },
  {
    id: 'p49',
    name: 'Coin Game (228/50)',
    category: 'Frames',
    price: 60,
    minQty: 12,
    description: 'Best Sheet Affordable Frames',
    image: '/product/frame27.jpeg',
    features: ['Metal', 'Stylish', 'Cicular Rectangle Shape'],
    inStock: true,
  },
  {
    id: 'p50',
    name: 'Coin Game (204/50)',
    category: 'Frames',
    price: 70,
    minQty: 12,
    description: 'Best Sheet Affordable Frames',
    image: '/product/frame29.jpeg',
    features: ['Sheet', 'Stylish', 'Rectangle Shape'],
    inStock: true,
  }
];

export const BLOG_POSTS: BlogPost[] =[
  {
    id: 'b1',
    title: 'Why Local Optical Stores Lose Margins — And How Smart Wholesale Fixes It',
    excerpt: 'Many optical stores lose profits without realizing the real cause. This article uncovers how inefficient wholesale sourcing silently reduces margins — and how a smarter supply system can restore stability and growth.',
    content: 'Many local optical stores believe that low profit margins are simply the result of heavy competition. In reality, the bigger issue often lies in inefficient wholesale sourcing. Unstable pricing, inconsistent stock availability, and dependence on unorganized suppliers slowly eat into margins without store owners realizing it. Each delayed delivery or sudden price change directly impacts daily sales and customer trust.This blog explains how a smart, organized wholesale system can help optical retailers regain control over pricing, inventory, and long-term profitability. It highlights the difference between short-term buying decisions and strategic bulk sourcing. The article is designed for optical store owners who want predictable margins, reliable supply, and sustainable business growth rather than constant price pressure',
  date: 'Dec 29, 2025',
    image: './blog1.png'
  },
  {
    id: 'b2',
    title: 'How Bulk Eyewear Buying Helps Clinics & Hospitals Reduce Costs Without Compromising Quality',
    excerpt: 'Bulk eyewear sourcing is more than just lower pricing. Discover how clinics and hospitals can reduce costs, maintain quality, and improve supply consistency through smarter wholesale partnerships.',
    content: 'Eyewear is often treated as a secondary offering in clinics and hospitals, but with the right sourcing strategy, it can become a cost-efficient and value-adding service. Bulk eyewear buying is not just about lower prices; it ensures consistent quality, standardized products, and better control over procurement costs.This blog explores how clinics and hospitals can use bulk frames and protective goggles to reduce operational expenses while maintaining professional quality standards. It also discusses how working with trusted wholesale suppliers improves inventory planning, minimizes shortages, and enhances patient satisfaction. The article is ideal for medical institutions looking to streamline eyewear procurement without sacrificing reliability or trust.',
    date: 'Dec 30, 2025',
    image: './blog2.png'
  },
  {
    id: 'b3',
    title: 'Frames, Goggles & Vision Products: What Retailers Should Check Before Choosing a Wholesale Supplier',
    excerpt: 'Price alone should never decide your wholesale supplier. Learn the critical factors every optical retailer must evaluate to ensure reliable supply, consistent quality, and long-term business success.',
    content: 'Choosing a wholesale eyewear supplier based only on price can lead to long-term business problems. Factors such as product consistency, stock reliability, delivery timelines, and after-sales support play a much bigger role in sustaining retail success. A weak supplier can disrupt inventory planning and damage customer confidence.This blog provides a practical checklist for retailers to evaluate wholesale suppliers before making sourcing decisions. It covers key points such as repeat order stability, quality control, replacement policies, and the advantages of working with organized, Delhi-based wholesalers. The goal is to help optical retailers avoid impulsive decisions and build dependable supply partnerships that support steady growth.',
    date: 'Dec 31, 2025',
    image: './blog3.png'
  }
];